module.exports = __webpack_public_path__ + "src/assets/games/23/506.jpg";